/**
 * Normalizes a URL by ensuring it has a protocol.
 * If the URL doesn't start with http:// or https://, it defaults to https://
 *
 * @param url - The URL to normalize
 * @returns The normalized URL with protocol, or empty string if input is empty
 *
 * @example
 * normalizeUrl('example.com') // returns 'https://example.com'
 * normalizeUrl('http://example.com') // returns 'http://example.com'
 * normalizeUrl('https://example.com') // returns 'https://example.com'
 */
export const normalizeUrl = (url: string): string => {
  if (!url) return ''

  if (/^https?:\/\//i.test(url)) {
    return url
  }

  return `https://${url}`
}
